import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";
import {stringify} from "qs";

let FeeStudentController = {
    viewFeeStudent: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee-student/view-fee-student?${stringify(payload)}`,
            method: 'GET'
        }, callback)
    },
    viewDetailFeeStudent: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee-student/view-detail-fee-student?${stringify(payload)}`,
            method: 'GET'
        }, callback)
    },
    detailFeeStudent: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee-student/detail-fee-student?${stringify(payload)}`,
            method: 'GET'
        }, callback)
    },
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee-student/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee-student/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    delete: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee/delete/${id}`,
            method: 'GET'
        }, callback)
    }
}

export default FeeStudentController
